/**
 * Premium Motion System (Framer Motion emulation)
 * Uses IntersectionObserver to trigger smooth CSS animations on scroll.
 */

document.addEventListener('DOMContentLoaded', () => {
    // Select elements to animate
    const animatedElements = document.querySelectorAll('.motion-fade-up, .motion-fade-in, .motion-stagger-children');

    // Configuration for the IntersectionObserver
    const options = {
        threshold: 0.15, // Trigger when 15% of element is visible
        rootMargin: '0px 0px -50px 0px' // Slightly offset trigger point
    };

    // Create the observer instance safely
    if (window.IntersectionObserver) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    // Stop observing once animated
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        if (animatedElements.length > 0) {
            animatedElements.forEach(el => observer.observe(el));
        }
    } else {
        // Fallback for browsers that don't support IntersectionObserver
        console.warn('IntersectionObserver not supported. Showing elements immediately.');
        if (animatedElements.length > 0) animatedElements.forEach(el => el.classList.add('is-visible'));
    }
});
